import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import { ButtonWrapper, CancelButtonWrapper, StyledOrderManagementInfo, LinkWithDisabledStyle, OrderManagementWrapper, BillingDetailsWrapper, OrderManagementButtons, TermsAndConditionsWrapper, OrderManagementRow, PaddingContainer } from './styled';
import { Button } from '@chegg-ui/button';
import TermsAndConditions from '../../modules/TermsAndConditions';
import { getParsedOrderManagementText, getRioErrorCallback, getRioSuccessCallback, getParsedButtonConditionsText, getOMActionType, getFailedActionMessage, getSuccessText, isSubscriptionLocked } from './helper';
import { API, fireStatusUpdate, StatusTypes, SpecType, SubType, ElementType, OneClickCommandNames, Namespace, parseMarkedDownText, LinkText, Component, TncInline, SubscriptionInfo, sendRioEvent, fireLogEvent, UserActions, APOLLO_COMMERCE_CONTEXT } from '@chegg/commerce-utils';
import { SmallNotificationBanner, NotificationTypes } from '@chegg-ui/notification-banner';
import { sendNewRelicError } from '../../utils/NewRelicUtils';
import { setApolloState } from '../../lib/ApolloSchema/apolloUtils';
import { getPrice, transformErrorObjectToStatusUpdate } from '../../utils/TransformUtils';
import { tncStringManipulation } from '../../utils/TncStringManipulation';
import { NOTIFICATION_BANNER_TESTID } from '../../constants/dataTestAttributes';
import { ORDER_MANAGEMENT_TESTID, CANCEL_BUTTON_TESTID, ORDER_MANAGEMENT_INFO_TESTID, TERMS_AND_CONDITIONS_TESTID, CTA_BUTTON_TESTID, BUTTON_CONDITIONS_TESTID, OMActionType } from './constants';
import useSendResumeRestartEvent from '../../hooks/useSendResumeRestartEvent';
import { GENERIC_ERROR_MESSAGE, MIGRATION_CTA_TEXT, MIGRATION_IN_PROGRESS_MESSAGE } from '../../constants/appConstants';
import { getClient } from '@chegg-web-tools/apollo-utils';
import { RESUME_USER_SUBSCRIPTION, UNDO_CANCEL_USER_SUBSCRIPTION, UNDO_PAUSE_USER_SUBSCRIPTION } from '../../gql/mutations';
import { Link } from '@chegg-ui/link';
var OrderManagement = function OrderManagement(_ref) {
  var content = _ref.content,
    price = _ref.price,
    priceWithoutCurrency = _ref.priceWithoutCurrency,
    currencyCode = _ref.currencyCode,
    totalRenewalPriceWithCurrency = _ref.totalRenewalPriceWithCurrency,
    namespace = _ref.namespace,
    action = _ref.action,
    orderLineId = _ref.orderLineId,
    token = _ref.token,
    renewalDate = _ref.renewalDate,
    cardType = _ref.cardType,
    last4 = _ref.last4,
    description = _ref.description,
    paymentAccountType = _ref.paymentAccountType,
    externalId = _ref.externalId,
    country = _ref.country,
    isRioInitialized = _ref.isRioInitialized,
    authorization = _ref.authorization,
    vpa = _ref.vpa,
    sendRioViewEvents = _ref.sendRioViewEvents,
    isRecurly = _ref.isRecurly,
    uuid = _ref.uuid,
    subscriptionId = _ref.subscriptionId;
  var subscriptionInfo = content.subscriptionInfo,
    cta = content.cta,
    orderManagementInfo = content.orderManagementInfo,
    buttonConditions = content.buttonConditions,
    termsAndConditions = content.termsAndConditions;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showErrorBanner = _useState4[0],
    setShowErrorBanner = _useState4[1];
  var _useState5 = useState(GENERIC_ERROR_MESSAGE),
    _useState6 = _slicedToArray(_useState5, 2),
    errorBannerMessage = _useState6[0],
    setErrorBannerMessage = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showOnlyTnc = _useState8[0],
    setShowOnlyTnc = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showCtaLink = _useState10[0],
    setShowCtaLink = _useState10[1];
  var displayPrice = getPrice({
    country: country,
    price: price,
    discountedPrice: undefined,
    priceTotalWithTaxCurrency: totalRenewalPriceWithCurrency
  });
  useEffect(function () {
    orderManagementInfo && setApolloState({
      uiData: {
        isLoaded: true
      }
    });
  }, [orderManagementInfo]);
  var orderContent = orderManagementInfo && getParsedOrderManagementText({
    paymentAccountType: paymentAccountType,
    content: orderManagementInfo,
    price: displayPrice,
    renewalDate: renewalDate,
    cardType: cardType,
    last4: last4,
    description: description,
    vpa: vpa
  });
  useSendResumeRestartEvent({
    isRioInitialized: isRioInitialized,
    action: action,
    namespace: namespace,
    externalId: externalId,
    priceWithoutCurrency: priceWithoutCurrency,
    currencyCode: currencyCode,
    sendRioViewEvents: sendRioViewEvents
  });

  /*istanbul ignore next*/
  var onCloseNotificationBanner = function onCloseNotificationBanner() {
    setShowErrorBanner(false);
  };
  var handleAPIErrorResponse = function handleAPIErrorResponse(_ref2) {
    var response = _ref2.response,
      action = _ref2.action,
      externalId = _ref2.externalId,
      namespace = _ref2.namespace;
    var omAction = getOMActionType(action);
    var omError = getFailedActionMessage(action);
    sendNewRelicError(omError, {
      errors: JSON.stringify(response === null || response === void 0 ? void 0 : response.errors),
      externalId: externalId,
      action: action
    });
    sendRioEvent({
      info: response === null || response === void 0 ? void 0 : response.errors[0].message,
      specType: SpecType.NOTIFICATION,
      callback: getRioErrorCallback(omAction),
      namespace: namespace
    });
  };
  var handleAPISuccessResponse = function handleAPISuccessResponse(_ref3) {
    var action = _ref3.action,
      externalId = _ref3.externalId,
      namespace = _ref3.namespace;
    var omAction = getOMActionType(action);
    var successText = getSuccessText(action);
    sendNewRelicError(successText, {
      externalId: externalId,
      action: action
    });
    sendRioEvent({
      info: successText,
      specType: SpecType.SUCCESS,
      callback: getRioSuccessCallback(omAction),
      namespace: namespace
    });
  };
  var apolloContext = _defineProperty({
    headers: {
      'X-CHEGG-USER-UUID': uuid
    }
  }, APOLLO_COMMERCE_CONTEXT, true);
  var handleCTAClickLegacy = function handleCTAClickLegacy() {
    if (getOMActionType(action) === OMActionType.RESUME) {
      void API.resume({
        orderLineId: orderLineId,
        token: token
      })["catch"](function (error) {
        return {
          errors: [error]
        };
      }).then(function (response) {
        if (response.errors) {
          if (isSubscriptionLocked(response)) {
            setShowCtaLink(true);
            setErrorBannerMessage(MIGRATION_IN_PROGRESS_MESSAGE);
          }
          setIsLoading(false);
          handleAPIErrorResponse({
            response: response,
            action: action,
            externalId: externalId,
            namespace: namespace
          });
          setShowErrorBanner(true);
        } else {
          setShowCtaLink(false);
          handleAPISuccessResponse({
            action: action,
            externalId: externalId,
            namespace: namespace
          });
          setShowErrorBanner(false);
        }
      });
    } else {
      void API.undoCancel({
        orderLineId: orderLineId,
        token: token
      })["catch"](function (error) {
        return {
          errors: [error]
        };
      }).then(function (response) {
        if (response.errors) {
          setIsLoading(false);
          handleAPIErrorResponse({
            response: response,
            action: action,
            externalId: externalId,
            namespace: namespace
          });
          setShowErrorBanner(true);
        } else {
          handleAPISuccessResponse({
            action: action,
            externalId: externalId,
            namespace: namespace
          });
          setShowErrorBanner(false);
        }
      });
    }
  };
  var handleCTAClickRecurly = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var client, _data$undoCancelUserS, _yield$client$mutate, data, errors, _data$undoPauseUserSu, _yield$client$mutate2, _data, _errors, _data2$resumeUserSubs, _yield$client$mutate3, _data2, _errors2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            client = getClient();
            _context.t0 = action;
            _context.next = _context.t0 === UserActions.REVOKE_PENDING_CANCEL ? 4 : _context.t0 === UserActions.REVOKE_PENDING_PAUSE ? 11 : _context.t0 === UserActions.RESUME ? 18 : 25;
            break;
          case 4:
            _context.next = 6;
            return client.mutate({
              mutation: UNDO_CANCEL_USER_SUBSCRIPTION,
              variables: {
                undoCancelSubscriptionInput: {
                  userSubscriptionIdInput: {
                    subscriptionId: subscriptionId
                  }
                }
              },
              context: apolloContext
            });
          case 6:
            _yield$client$mutate = _context.sent;
            data = _yield$client$mutate.data;
            errors = _yield$client$mutate.errors;
            if (data !== null && data !== void 0 && (_data$undoCancelUserS = data.undoCancelUserSubscription) !== null && _data$undoCancelUserS !== void 0 && (_data$undoCancelUserS = _data$undoCancelUserS.userSubscription) !== null && _data$undoCancelUserS !== void 0 && _data$undoCancelUserS.id) {
              handleAPISuccessResponse({
                action: action,
                externalId: externalId,
                namespace: namespace
              });
              setShowErrorBanner(false);
            } else {
              setIsLoading(false);
              handleAPIErrorResponse({
                response: errors,
                action: action,
                externalId: externalId,
                namespace: namespace
              });
              setShowErrorBanner(true);
            }
            return _context.abrupt("break", 25);
          case 11:
            _context.next = 13;
            return client.mutate({
              mutation: UNDO_PAUSE_USER_SUBSCRIPTION,
              variables: {
                undoPauseSubscriptionInput: {
                  userSubscriptionIdInput: {
                    subscriptionId: subscriptionId
                  }
                }
              },
              context: apolloContext
            });
          case 13:
            _yield$client$mutate2 = _context.sent;
            _data = _yield$client$mutate2.data;
            _errors = _yield$client$mutate2.errors;
            if (_data !== null && _data !== void 0 && (_data$undoPauseUserSu = _data.undoPauseUserSubscription) !== null && _data$undoPauseUserSu !== void 0 && (_data$undoPauseUserSu = _data$undoPauseUserSu.userSubscription) !== null && _data$undoPauseUserSu !== void 0 && _data$undoPauseUserSu.id) {
              handleAPISuccessResponse({
                action: action,
                externalId: externalId,
                namespace: namespace
              });
              setShowErrorBanner(false);
            } else {
              setIsLoading(false);
              handleAPIErrorResponse({
                response: _errors,
                action: action,
                externalId: externalId,
                namespace: namespace
              });
              setShowErrorBanner(true);
            }
            return _context.abrupt("break", 25);
          case 18:
            _context.next = 20;
            return client.mutate({
              mutation: RESUME_USER_SUBSCRIPTION,
              variables: {
                resumeSubscriptionInput: {
                  userSubscriptionIdInput: {
                    subscriptionId: subscriptionId
                  }
                }
              },
              context: apolloContext
            });
          case 20:
            _yield$client$mutate3 = _context.sent;
            _data2 = _yield$client$mutate3.data;
            _errors2 = _yield$client$mutate3.errors;
            if (_data2 !== null && _data2 !== void 0 && (_data2$resumeUserSubs = _data2.resumeUserSubscription) !== null && _data2$resumeUserSubs !== void 0 && (_data2$resumeUserSubs = _data2$resumeUserSubs.userSubscription) !== null && _data2$resumeUserSubs !== void 0 && _data2$resumeUserSubs.id) {
              handleAPISuccessResponse({
                action: action,
                externalId: externalId,
                namespace: namespace
              });
              setShowErrorBanner(false);
            } else {
              setIsLoading(false);
              handleAPIErrorResponse({
                response: _errors2,
                action: action,
                externalId: externalId,
                namespace: namespace
              });
              setShowErrorBanner(true);
            }
            return _context.abrupt("break", 25);
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleCTAClickRecurly() {
      return _ref4.apply(this, arguments);
    };
  }();
  var onCTAClick = function onCTAClick() {
    setIsLoading(true);
    if (isRecurly) {
      handleCTAClickRecurly();
    } else {
      handleCTAClickLegacy();
    }
    sendRioEvent({
      info: getOMActionType(action) === OMActionType.RESUME ? LinkText.RESUME_SUBSCRIPTION : LinkText.RESTART_SUBSCRIPTION,
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: fireLogEvent,
      namespace: namespace
    });
  };
  var onCancelClick = function onCancelClick(e) {
    e.preventDefault();
    if (isLoading) return;
    fireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      command: OneClickCommandNames.EXIT_ONE_CLICK,
      payload: {
        component: Component.ORDER_MANAGEMENT,
        data: {
          action: 'clicks back'
        }
      }
    }], Namespace.ONE_CLICK);
    sendRioEvent({
      info: LinkText.CLICK_BACK,
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: fireLogEvent,
      namespace: namespace
    });
  };

  /* istanbul ignore next */
  var onError = function onError(error) {
    fireStatusUpdate(transformErrorObjectToStatusUpdate(error), Namespace.ONE_CLICK);
  };
  var buttonConditionsContent = buttonConditions && getParsedButtonConditionsText({
    content: buttonConditions,
    cta: cta,
    price: displayPrice
  });
  return /*#__PURE__*/React.createElement(OrderManagementWrapper, {
    "data-test": ORDER_MANAGEMENT_TESTID
  }, /*#__PURE__*/React.createElement(SubscriptionInfo, {
    content: subscriptionInfo,
    headingLevel: 2,
    price: displayPrice,
    authorization: authorization,
    onError: onError
  }), showErrorBanner && /*#__PURE__*/React.createElement(PaddingContainer, {
    bottom: 10
  }, /*#__PURE__*/React.createElement(SmallNotificationBanner, {
    id: 'SmallNotificationBanner',
    "data-test": NOTIFICATION_BANNER_TESTID,
    type: NotificationTypes.Error,
    message: errorBannerMessage,
    onCloseClick: onCloseNotificationBanner,
    ctaLink: showCtaLink ? /*#__PURE__*/React.createElement(Link, {
      href: '/contactus'
    }, MIGRATION_CTA_TEXT) : undefined
  })), orderManagementInfo && /*#__PURE__*/React.createElement(StyledOrderManagementInfo, {
    "data-test": ORDER_MANAGEMENT_INFO_TESTID,
    dangerouslySetInnerHTML: parseMarkedDownText(orderContent)
  }), buttonConditions && /*#__PURE__*/React.createElement(BillingDetailsWrapper, {
    "data-test": BUTTON_CONDITIONS_TESTID
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: parseMarkedDownText(buttonConditionsContent)
  })), /*#__PURE__*/React.createElement(OrderManagementRow, null, termsAndConditions && /*#__PURE__*/React.createElement(TermsAndConditionsWrapper, {
    "data-test": TERMS_AND_CONDITIONS_TESTID
  }, /*#__PURE__*/React.createElement(TermsAndConditions, {
    termsAndConditions: termsAndConditions,
    isOpen: showOnlyTnc,
    tncPromptText: /*#__PURE__*/React.createElement(TncInline, {
      onError: onError,
      content: termsAndConditions,
      onRioEventFired: fireLogEvent,
      price: displayPrice,
      namespace: namespace,
      isOpen: showOnlyTnc,
      isOpenCallback: setShowOnlyTnc,
      formattedTermsContent: tncStringManipulation(termsAndConditions.content.json, displayPrice),
      ctaLabel: cta.cta
    })
  })), /*#__PURE__*/React.createElement(OrderManagementButtons, null, /*#__PURE__*/React.createElement(ButtonWrapper, null, /*#__PURE__*/React.createElement(CancelButtonWrapper, null, cta && /*#__PURE__*/React.createElement(LinkWithDisabledStyle, {
    onClick: onCancelClick,
    "data-test": CANCEL_BUTTON_TESTID,
    hasButtonBehavior: true,
    href: isLoading ? '' : '#',
    role: 'button',
    disabled: isLoading,
    "aria-disabled": isLoading,
    tabIndex: isLoading ? -1 : 0
  }, cta.cancelButtonText)), cta && /*#__PURE__*/React.createElement(Button, {
    "data-test": CTA_BUTTON_TESTID,
    onClick: onCTAClick,
    disabled: isLoading,
    isLoading: isLoading,
    size: 'medium',
    disableHoverAnimation: true
  }, cta.cta)))));
};
export default OrderManagement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/OrderManagement/index.js
// module id = 4712
// module chunks = 11